import { Navigate } from "react-router-dom";

const RootRedirect = () => {
  const lang = localStorage.getItem("language") || "az";
  return <Navigate to={`/${lang}`} replace />;
};

export default RootRedirect;
